import { Instance, types } from "mobx-state-tree";

import { MesssageModel, ValidationMesssage } from "./ValidationMesssage";

export const ValidatorModel = types.model({}).actions((self) => ({
  validate(value: any): ValidationMesssage {
    return {
      message: MesssageModel.create({}),
      context: "",
    };
  },
}));

export type Validator = Instance<typeof ValidatorModel>;
